const en = {
    accept: "Accept",
    changeLanguage: "Change language",
    footer: {
        mainPage: {
            mainPageText1: "PERSONALIZED SOLUTIONS. EXACTLY THE WAY YOU WANT.",
            askForOffer: "Ask for offer now!",
            aboutUs: "About us",
            solutions: "Solutions",
            socialMedia: "Social media",
            aboutInvitech: "About One",
            references: "References",
            career: "Career",
            socialResponsibility: "Social responsibility",
            centralizedProcurement: "Centralized procurement",
            smartVillage: "Smart village",
            forLargeCompanies: "For large companies",
            forSmallAndMediumCompanies: "For small and medium companies",
            forInstitutions: "For institutions",
            forWholesalers: "For wholesalers",
            businessServices: "Business services",
            infrastructureServices: "Infrastructure services",
            news: "News",
            press: "Press",
            blog: "Blog",
            loginToCustomerPortal: "Login to the customer portal",
            loginToTechnicalPortal: "Login to the technical portal"
        },
        dataProtection: "Data protection",
        dataProcessingCode: "Data processing code",
        termsAndConditions: "Terms and Conditions",
        gtc: "GTC",
        certificates: "Certificates",
        impress: "Impress",
        providerInformation: "Provider information",
        filteringSoftware: "Filtering Software",
        coServiceOffers: "Co-service offers",
        premiumServices: "Premium services",
        socialResponsibility: "Social responsibility (InnoMax)",
        iivrApplication: "IIVR Application"
    },
    urls: {
        aboutInvitech: "https://www.invitech.hu/invitechrol",
        references: "https://www.invitech.hu/ugyfeleink",
        socialResponsibility: "https://www.invitech.hu/innomax-fooldal",
        centralizedProcurement: "https://www.invitech.hu/kozpontositott-beszerzes",
        forLargeCompanies: "https://www.invitech.hu/vallalati-szolgaltatasok-gyujto",
        forSmallAndMediumCompanies: "https://www.invitech.hu/kis-es-kozepvallalkozasok-gyujto",
        forInstitutions: "https://www.invitech.hu/kozpontositott-beszerzes",
        businessServices: "https://www.invitech.hu/vallalati-szolgaltatasok-gyujto",
        infrastructureServices: "https://www.invitech.hu/infrastruktura",
        news: "https://www.invitech.hu/hirek",
        dataProcessingCode: "https://www.invitech.hu/storage/pbB0key1ENoZhpMpb0LVtlWc9sgyyEU6eIrQ98by.pdf",
        gtc: "https://www.invitech.hu/altalanos-szerzodesi-feltetelek-invitech",
        certificates: "https://www.invitech.hu/tanusitvanyaink",
        impress: "https://www.invitech.hu/impresszum",
        providerInformation: "https://www.invitech.hu/szolgaltato-adatai"
    },
    fields: {
        companyName: "Company Name",
        taxNumber: "TAX Number",
        giroNumber: "Contract Giro Number",
        contact: "Contact",
        position: "Position",
        mobile: "Mobile Number",
        email: "Email"
    },
    cannotBeEmpty: "Cannot be empty",
    formatError: "Format error",
    mobileFormatError: "Format error (eg. +36...)",
    taxFormatError: "Format error (pl. 12345678-1-12)",
    registration: "Registration",
    regDescr: "In order to protect your data, only one contact person, indicated in your contract, can register your company or institution. Your colleagues can be invited by a main contact person who is already registered, and you should designate an operational person to do this. For your staff, you can define individual rights according to their role.",
    mandatory: "Mandatory",
    success: "Success",
    errorDuringRegistration: "Error during the registration process. Please try again!"
};

export default en;
